<template>
  <div class="ad-pool-settlement-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-input
              v-model.trim="searchUserId"
              placeholder="用户 ID"
              prefix-icon="el-icon-user"
              clearable
              class="filter-input filter-input-sm"
              @keyup.enter.native="handleSearch"
            />
            <el-input
              v-model.trim="searchAdRecordId"
              placeholder="开包广告 ID"
              prefix-icon="el-icon-document"
              clearable
              class="filter-input filter-input-sm"
              @keyup.enter.native="handleSearch"
            />
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              class="filter-daterange"
              @change="handleSearch"
            />
            <date-range-quick v-model="dateRange" @change="handleSearch" />
            <el-button type="primary" icon="el-icon-search" :loading="loading" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>

      <el-table
        v-else
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="正在加载..."
        row-key="id"
      >
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="userId" label="用户 ID" min-width="100" align="center" />
        <el-table-column prop="adRecordId" label="开包广告 ID" min-width="120" align="center" />
        <!-- 本次开红包 × 用户分成后的金币 -->
        <el-table-column prop="rewardUserCoins" label="开包金币" min-width="110" align="center" />
        <!-- 开包前暂存池已叠（叠包累计，已乘分成） -->
        <el-table-column prop="poolEcpm" label="累计已叠金币" min-width="120" align="center" />
        <!-- 提升激励 + 开红包真实金币合计（未乘分成） -->
        <el-table-column prop="totalRawCoins" label="总金币" min-width="110" align="center" />
        <!-- 开包入账 = 已叠 + 本次，已乘用户分成 -->
        <el-table-column prop="totalUserCoins" label="用户收入金币" min-width="120" align="center" />
        <el-table-column prop="createdAt" label="开包时间" min-width="170" align="center" show-overflow-tooltip />
      </el-table>

      <div v-if="!error && !loading && list.length === 0" class="empty-state">
        <el-empty description="暂无叠包开包流水" />
      </div>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from '@/utils/http'
import { getDefaultDateRange } from '@/utils/dateRange'
import DateRangeQuick from '@/components/DateRangeQuick.vue'

export default {
  name: 'AdPoolSettlementManagement',
  components: { DateRangeQuick },
  data() {
    return {
      loading: false,
      error: '',
      list: [],
      searchUserId: '',
      searchAdRecordId: '',
      dateRange: getDefaultDateRange(),
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    parsePositiveInt(value) {
      if (value === '' || value == null) {
        return null
      }
      const parsed = parseInt(String(value).trim(), 10)
      return Number.isNaN(parsed) || parsed <= 0 ? null : parsed
    },
    buildQuery() {
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      const userId = this.parsePositiveInt(this.searchUserId)
      const adRecordId = this.parsePositiveInt(this.searchAdRecordId)
      if (userId != null) {
        params.userId = userId
      }
      if (adRecordId != null) {
        params.adRecordId = adRecordId
      }
      const [start, end] = this.dateRange || []
      if (start) params.startTime = start
      if (end) params.endTime = end
      return params
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const result = await get('/admin/ad-pool/settlement/page', this.buildQuery())
        const data = result.data || {}
        this.list = Array.isArray(data.records) ? data.records : []
        this.pagination.total = data.total || 0
        this.pagination.page = data.page || this.pagination.page
        this.pagination.pageSize = data.pageSize || this.pagination.pageSize
      } catch (e) {
        this.error = e.message || '加载失败'
        this.list = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    resetSearch() {
      this.searchUserId = ''
      this.searchAdRecordId = ''
      this.dateRange = getDefaultDateRange()
      this.pagination.page = 1
      this.fetchList()
    },
    refreshList() {
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 16px;
}
.filter-bar {
  margin-bottom: 0;
}
.filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.filter-input-sm {
  width: 160px;
}
.filter-daterange {
  width: 380px;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.error {
  color: #f56c6c;
  margin-bottom: 12px;
}
.empty-state {
  padding: 24px 0;
}
</style>
